// extracted by mini-css-extract-plugin
export default {"otherChoiceInput":"otherChoiceInput__o83Jc"};